import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-ppm',
  templateUrl: './ppm.component.html',
  styleUrls: ['./ppm.component.scss']
})
export class PPMComponent implements OnInit, OnDestroy {

  private ngUnsubscribe: Subject<void>; //Permet de grabber tout ce qu'on doit finallement unsubscribe.

  public currentLang: string;
  
  // tslint:disable:max-line-length
  taquets;
  faq = {
    title: 'Questions et réponses',
    questions: [
      {
        question: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit?',
        answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis voluptatem nisi quisquam? Dignissimos totam dolore doloribus ullam ex esse perspiciatis, dolor tempore deleniti eveniet laborum laboriosam, ab eaque iure pariatur.'
      },
      {
        question: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit?',
        answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis voluptatem nisi quisquam? Dignissimos totam dolore doloribus ullam ex esse perspiciatis, dolor tempore deleniti eveniet laborum laboriosam, ab eaque iure pariatur.'
      },
      {
        question: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit?',
        answer: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis voluptatem nisi quisquam? Dignissimos totam dolore doloribus ullam ex esse perspiciatis, dolor tempore deleniti eveniet laborum laboriosam, ab eaque iure pariatur.'
      }
    ]
  };

  constructor(private route: ActivatedRoute, private translateService: TranslateService ) {
    this.currentLang = this.translateService.currentLang;
    this.taquets = this.route.snapshot.data.taquets;
    this.ngUnsubscribe = new Subject<void>();
  }

  ngOnInit() {

    this.translateService.onLangChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe((event: LangChangeEvent) => {
      this.currentLang = event.lang
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }​​​​​​​​

}
